<div class="px-4 py-10 bg-white/90 backdrop-blur-md" *ngIf="utilisateur">
  <!-- Formulaire d'affichage -->
  <div *ngIf="currentStep !== 2"
    class="max-w-4xl p-8 mx-auto border border-gray-200 shadow-md bg-white/90 backdrop-blur-md rounded-2xl">
    <div class="flex items-center gap-6">
      <div class="flex items-center justify-center w-24 h-24 text-3xl bg-gray-100 border border-gray-300 rounded-full">
        {{ utilisateur.nom && utilisateur.nom[0] ?
        utilisateur.nom[0].toUpperCase() : '' }}{{
        utilisateur.prenom && utilisateur.prenom[0] ?
        utilisateur.prenom[0].toUpperCase() : '' }}
      </div>
      <div>
        <h2 class="text-2xl font-bold text-gray-800">{{ utilisateur.nom }} {{
          utilisateur.prenom }}</h2>
        <p class="text-gray-600">Role: {{ utilisateur.role }}</p>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
      <div>
        <label class="block text-gray-700">Nom d'utilisateur</label>
        <p class="mt-1 font-medium text-gray-800">{{ utilisateur.userName }}</p>
      </div>
      <div>
        <label class="block text-gray-700">Email</label>
        <p class="mt-1 font-medium text-gray-800">{{ utilisateur.email }}</p>
      </div>
      <div>
        <label class="block text-gray-700">Statut</label>
        <p class="mt-1">
          <span
            class="px-2 py-1 rounded-full text-sm font-semibold {{ utilisateur.active ? 'bg-green-100 text-green-800 border border-green-200' : 'bg-red-100 text-red-800 border border-red-200' }}">
            {{ utilisateur.active ? 'Actif' : 'Inactif' }}
          </span>
        </p>
      </div>
      <div>
        <label class="block text-gray-700">Signature</label>
        <p class="mt-1 font-medium text-gray-800">
          {{ utilisateur.signature ? "✅ Ajouté": '❌ Non définie' }}
        </p>
      </div>
      <div class="md:col-span-2">
        <label class="block text-gray-700">Inspection associée</label>
        <p class="mt-1 font-medium text-gray-800">
          {{ utilisateur.inspection?.nom ?? 'Aucune' }}
        </p>
      </div>
    </div>
    <button type="button" (click)="onStepChange(2)"
      class="mt-6 flex items-center gap-2 text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-6 py-2.5 focus:outline-none">
      Modifier
    </button>
  </div>

  <!-- Formulaire d'édition -->
  <div [ngClass]="{'animate-slide-in-right': currentStep === 2, 'hidden': currentStep !== 2}"
    class="max-w-4xl p-8 mx-auto border border-gray-200 shadow-md bg-white/90 backdrop-blur-md rounded-2xl">
    <div class="flex items-center gap-6 mb-6">
      <div class="flex items-center justify-center w-24 h-24 text-3xl bg-gray-100 border border-gray-300 rounded-full">
        {{ utilisateur.nom && utilisateur.nom[0] ?
        utilisateur.nom[0].toUpperCase() : '' }}{{
        utilisateur.prenom && utilisateur.prenom[0] ?
        utilisateur.prenom[0].toUpperCase() : '' }}
      </div>
      <h2 class="text-2xl font-bold text-gray-800">Modifier l'utilisateur</h2>
    </div>

    <form (ngSubmit)="onSubmit()">
      <div class="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
        <div>
          <label for="nom" class="block mb-2 text-sm font-medium text-gray-700">Nom</label>
          <input type="text" id="nom" [(ngModel)]="utilisateur.nom" name="nom"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>
        <div>
          <label for="prenom" class="block mb-2 text-sm font-medium text-gray-700">Prénom</label>
          <input type="text" id="prenom" [(ngModel)]="utilisateur.prenom" name="prenom"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>
        <div>
          <label for="userName" class="block mb-2 text-sm font-medium text-gray-700">Nom
            d'utilisateur</label>
          <input type="text" id="userName" [(ngModel)]="utilisateur.userName" name="userName"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>
        <div>
          <label for="email" class="block mb-2 text-sm font-medium text-gray-700">Email</label>
          <input type="email" id="email" [(ngModel)]="utilisateur.email" name="email"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>
        <div>
          <label for="motDePasse" class="block mb-2 text-sm font-medium text-gray-700">Mot de Passe</label>
          <input type="password" id="motDePasse" [(ngModel)]="utilisateur.motDePasse" name="motDePasse"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <!-- Sélection de la méthode de signature -->
        <div class="md:col-span-2">
          <label class="block mb-4 text-sm font-medium text-gray-700">Méthode de
            signature</label>
          <div class="flex gap-6">
            <label class="flex items-center">
              <input type="radio" name="signatureMethod" [value]="'draw'" [(ngModel)]="signatureMethod" class="mr-2">
              Dessiner la signature
            </label>
            <label class="flex items-center">
              <input type="radio" name="signatureMethod" [value]="'upload'" [(ngModel)]="signatureMethod" class="mr-2">
              Importer une image
            </label>
          </div>
        </div>

        <!-- Zone de dessin de signature -->
        <div class="md:col-span-2" *ngIf="signatureMethod === 'draw'">
          <label class="block mb-2 text-sm font-medium text-gray-700">Dessiner
            votre signature</label>
          <canvas #canvas class="w-full border border-gray-300 rounded-lg h-72"></canvas>

          <div class="flex gap-2 mt-3">
            <button type="button" (click)="clearSignature()"
              class="px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600">
              Effacer
            </button>
            <button type="button" (click)="saveSignature()"
              class="px-4 py-2 text-white bg-green-500 rounded-lg hover:bg-green-600">
              Sauvegarder
            </button>
          </div>

          <!-- Aperçu signature dessinée -->
          <div *ngIf="savedSignature" class="mt-4">
            <p class="mb-2 text-sm text-gray-600">Aperçu de la signature:</p>
            <img [src]="savedSignature" class="h-20 border border-gray-300 rounded" />
          </div>
        </div>

        <!-- Zone d'upload de signature -->
        <div class="md:col-span-2" *ngIf="signatureMethod === 'upload'">
          <label class="block mb-2 text-sm font-medium text-gray-700">Importer
            une signature</label>

          <!-- Aperçu de l'image actuelle -->
          <div *ngIf="utilisateur.signature" class="mb-4">
            <p class="mb-2 text-sm text-gray-600">Signature actuelle:</p>
            <img [src]="utilisateur.signature" alt="Signature actuelle" class="h-20 border border-gray-300 rounded">
            <button type="button" (click)="utilisateur.signature = null; savedSignature = null;"
              class="ml-2 text-sm text-red-600 hover:text-red-800">
              Supprimer
            </button>
          </div>

          <!-- Champ d'upload -->
          <div class="flex items-center">
            <label for="signature-upload"
              class="cursor-pointer bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 hover:bg-gray-50">
              <span *ngIf="!fileSelected">Choisir une image...</span>
              <span *ngIf="fileSelected" class="text-gray-800">{{
                selectedFileName }}</span>
            </label>
            <input id="signature-upload" type="file" accept="image/*" (change)="onFileSelected($event)" class="hidden">
          </div>

          <p class="mt-1 text-xs text-gray-500">Formats supportés: JPG, PNG (max
            10MB)</p>
        </div>
      </div>

      <div class="flex justify-end gap-4 mt-6">
        <button type="button" (click)="onStepChange(1)"
          class="px-6 py-2.5 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200">
          Annuler
        </button>
        <button type="submit"
          class="px-6 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300">
          Enregistrer
        </button>
      </div>
    </form>
  </div>
</div>